export default __webpack_public_path__ + "static/media/myphone.88bd70ab.svg";